import React from "react";
import { useTranslation } from 'react-i18next';
import profilePic from "../assets/profile-pic.png";
import igImage from "../assets/igImage.jpg";

// Icons
import heart from "../assets/heart.svg";
import comment from "../assets/comment.svg";
import share from "../assets/share.svg";
import save from "../assets/save.svg";

import "./Social.css";
import FadeInSection from './FadeInSection';

// Helper: calculate relative time
const timeAgo = (timestamp) => {
  const diff = (new Date() - new Date(timestamp)) / 1000;
  const units = [
    { max: 60, value: 1, label: 's' },
    { max: 3600, value: 60, label: 'm' },
    { max: 86400, value: 3600, label: 'h' },
    { max: 604800, value: 86400, label: 'd' },
    { max: Infinity, value: 604800, label: 'w' }
  ];
  for (const { max, value, label } of units) {
    if (diff < max) return `${Math.floor(diff / value)}${label}`;
  }
  return '0s';
};

const Social = ({ feeds = [] }) => {
  const { t } = useTranslation();

  return (
    <FadeInSection>
      <section className="social-section">
        <div className="container">
          <div className="stay-connected">
            <div className="d-flex align-items-center">
              <h2 className="ml-2">{t('social.stayConnected.header')}</h2>
            </div>
            <p>{t('social.stayConnected.description')}</p>
          </div>

          <div className="instagram-feed row">
            {feeds.length > 0 ? (
              feeds.slice(0, 3).map((feed, index) => {
                const isVideoLike = feed.media_type === "VIDEO" || !!feed.thumbnail_url;

                return (
                  <div className="col-md-4 d-flex align-items-center justify-content-center" key={feed.id || index}>
                    <a href={feed.permalink} target="_blank" rel="noopener noreferrer" className="instagram-card-link">
                      <div className="instagram-card">
                        <div className="card-header">
                          <img src={profilePic} alt="Username" className="profile-pic" />
                          <span>ondrejstaidl</span>
                        </div>

                        <div className="card-image">
                          <img
                            src={isVideoLike ? feed.thumbnail_url : feed.media_url}
                            alt={`Instagram Post ${index + 1}`}
                          />

                          {/* Centered play overlay (same look as MyApproach/Testimonials) */}
                          {isVideoLike && (
                            <div className="ig-play-overlay">
                              <button
                                className="ig-play-circle"
                                aria-label={t("social.playOnInstagram")}
                                // No onClick: let the surrounding <a> handle navigation
                              />
                              <button
                                className="ig-play-tag"
                                aria-label={t("social.playOnInstagram")}
                              >
                                {t("social.playOnInstagram")}
                              </button>
                            </div>
                          )}
                        </div>

                        <div className="card-footer d-flex justify-content-between align-items-center">
                          <div className="icons-left">
                            <img src={heart} alt="Heart Icon" className="icon" />
                            <img src={comment} alt="Comment Icon" className="icon" />
                            <img src={share} alt="Share Icon" className="icon" />
                          </div>
                          <div className="icon-right">
                            <img src={save} alt="Save Icon" className="icon" />
                          </div>
                        </div>

                        <div className="caption-snippet d-flex justify-content-between align-items-center">
                          <span>
                            {feed.caption?.split("\n")[0].slice(0, 100)}
                            {feed.caption?.length > 100 && '...'}
                          </span>
                          <span className="post-time">{timeAgo(feed.timestamp)}</span>
                        </div>
                      </div>
                    </a>
                  </div>
                );
              })
            ) : (
              [0, 1, 2].map(index => (
                <div className="col-md-4 d-flex align-items-center justify-content-center" key={index}>
                  <div className="instagram-card">
                    <div className="card-header">
                      <img src={profilePic} alt="Username" className="profile-pic" />
                      <span>ondrejstaidl</span>
                    </div>
                    <div className="card-image">
                      <img src={igImage} alt={`Default Post ${index + 1}`} />
                    </div>
                    <div className="card-footer d-flex justify-content-between align-items-center">
                      <div className="icons-left">
                        <img src={heart} alt="Heart Icon" className="icon" />
                        <img src={comment} alt="Comment Icon" className="icon" />
                        <img src={share} alt="Share Icon" className="icon" />
                      </div>
                      <div className="icon-right">
                        <img src={save} alt="Save Icon" className="icon" />
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </section>
    </FadeInSection>
  );
};

export default Social;
